import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import RawmaterialDashboard from '../RawmaterialDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function RawmaterialPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < RawmaterialDashboard />
    )

}